import { QueryFactory } from '@lmt/shared-types';
import type { PageableListDtoOfDataBlockDto } from '@lmt/shared-types';
import type { GetDataBlockQueryParameters } from '@lmt/shared-types/src/api/api-client/DataBlockQuery';

type DataBlockBatchQueryParameters = Pick<
  GetDataBlockQueryParameters,
  'visitIds' | 'variant' | 'typeId'
>;

const visitBatchSize = 200;

export async function loadDataBlocksBatch(
  visitIds: number[],
  loadBatch: (ids: number[]) => Promise<PageableListDtoOfDataBlockDto>,
): Promise<PageableListDtoOfDataBlockDto> {
  const result: PageableListDtoOfDataBlockDto = { data: [], totalCount: 0 };
  for (let offset = 0; offset < visitIds.length; offset += visitBatchSize) {
    const batch = await loadBatch(
      visitIds.slice(offset, offset + visitBatchSize),
    );
    result.data.push(...batch.data);
    result.totalCount += batch.totalCount;
  }
  return result;
}

export function useDataBlockBatchQuery(params: DataBlockBatchQueryParameters) {
  return QueryFactory.DataBlockQuery.useGetQuery(params, {
    enabled: !!params.visitIds?.length,
    queryFn: ({ signal }) =>
      loadDataBlocksBatch(params.visitIds ?? [], (batch) =>
        QueryFactory.DataBlockClient.get(
          undefined, // patientId
          undefined, // caseId
          undefined, // visitId
          batch,
          undefined, // caseIds
          params.variant,
          params.typeId,
          undefined, // importIds
          undefined, // values
          undefined, // begin
          undefined, // pagination_Offset
          undefined, // pagination_Limit
          undefined, // sorting_SortField
          undefined, // sorting_SortDirection
          undefined, // additionalSorting
          { signal },
        ),
      ),
  });
}
